import { createContext } from 'react';

import { LoadStatus } from 'constants/aiProcessRuns';

// LEN-213: the run-wide guideline citations every AI Activity surface (step output,
// review-form values, transcript) resolves its citation markers against. Outside a
// provider nothing loads, so the default is a settled empty list — markers then render
// as neutral "unavailable" chips rather than an endless loading state.
const DEFAULT_VALUE = { citations: [], status: LoadStatus.READY };

export const AiActivityCitationsContext = createContext(DEFAULT_VALUE);
